export function safeLatOrLong(latOrLong: number): string {
  return latOrLong.toFixed(5);
}
